module.exports = __webpack_public_path__ + "img/24_hide.4dc30004.svg";